<!--
 * @Author: Jason
 * @Date: 2020-09-11 14:03:51
 * @LastEditors: Jason
 * @LastEditTime: 2020-09-11 20:18:22
-->
<template>
    <div class="container">
      <p>请用【吃奶了】小程序扫下面二维码绑定宝贝信息</p>
      <p><br></p>
      <qrcode-vue v-if="qrcode.value" :value="qrcode.value" :size="qrcode.size"></qrcode-vue>
    </div>
</template>

<script>
import bus from '../common/bus';
import { mapState } from "vuex";
export default {
    name: 'Home',
    computed: {
      ...mapState(["LoginInfo"])
    },
    watch: {
        "LoginInfo.token"(val) {
            console.log(val)
            if (val) {
                this.qrcode.value = val
            }
        }
    },
    data() {
        return {
            qrcode: {
                value: '',
                size: 150
            }
        };
    },
    created () {
        this.qrcode.value = this.LoginInfo.token
    },
    methods: {

    }
};
</script>


<style scoped>
.container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue